export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const CART_QUANTITY = "CART_QUANTITY";
export const ONCHANGE_CART_QUANTITY = "ONCHANGE_CART_QUANTITY";
export const CLEAR_CART_ITEMS = "CLEAR_CART_ITEMS"
export const ADD_TOTAL_AMOUNT = "ADD_TOTAL_AMOUNT";
